<template>
    <v-dialog
        :value="isVisible"
        @input="abort"
        persistent scrollable
        max-width="900px"
    >
        <v-card>
            <v-card-title>
                <div class="text-h5">
                    {{ title }}
                </div>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <slot />
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text @click="abort">Отмена</v-btn>
                <v-btn text color="blue darken-1" @click="save">Сохранить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Vue from 'vue'
import {Prop} from 'vue-property-decorator'

@Component({
    components: {},
})
export default class FormDialog extends Vue
{
    @Prop(String)
    title!: string

    @Prop({type: Boolean, default: false})
    isVisible!: boolean

    abort() {
        this.$emit('abort')
    }

    save() {
        this.$emit('save')
    }
}
</script>
